export default function fillTemplate(template: string | undefined, params: Record<string,string>) {
  const filledString = (template && Object.entries(params).reduce((acc, [key, value]) => {
    return acc.split(`{{${key}}}`).join(value)
  }, template)) || ''
  return filledString
}